import audioManager from '../audio/audioManager'
import { events } from '../config/events'
import { utils } from 'pixi.js'

const emitter = new utils.EventEmitter()

const MUSIC_STATE_STORAGE_KEY = 'music_active'

let helpActive = false
let musicActive = false
let initialized = false
let musicButtons: HTMLElement[] = []

function loadMusicStateFromStorage(): boolean {
  try {
    const stored = localStorage.getItem(MUSIC_STATE_STORAGE_KEY)
    if (stored !== null) {
      return stored === 'true'
    }
  } catch (err) {
    console.warn('[buttons] Failed to load music state from localStorage:', err)
  }
  // Default to true (music playing) if no stored state
  return true
}

function saveMusicStateToStorage(active: boolean): void {
  try {
    localStorage.setItem(MUSIC_STATE_STORAGE_KEY, String(active))
  } catch (err) {
    console.warn('[buttons] Failed to save music state to localStorage:', err)
  }
}

function init() {
  if (initialized) return
  initialized = true

  document.getElementById('activity-help-button')?.addEventListener('click', onHelpClick)

  musicButtons = Array.from(document.querySelectorAll<HTMLElement>('#music-button, #music-button-mobile'))
  musicButtons.forEach((btn) => btn.addEventListener('click', onMusicClick))

  // Load music state from localStorage
  musicActive = loadMusicStateFromStorage()
  updateMusicButtons()

  // Note: Music state is applied when music actually starts (in soundController.startMusic())
  // We don't call toggleMusic() here because audio hasn't started yet - it only starts
  // after user interaction (clicking the enter button)
}

const on = emitter.on.bind(emitter)
const off = emitter.off.bind(emitter)

function onHelpClick(e: Event) {
  // e.preventDefault()
  // const btn = e.currentTarget as HTMLElement
  // helpActive = !helpActive
  // btn.classList.toggle('off', !helpActive)
  // btn.blur()
  // emitter.emit(events.HELP_BUTTON_CLICK, helpActive)
}

function onMusicClick(e: Event) {
  e.preventDefault()
  ;(e.currentTarget as HTMLElement).blur()

  musicActive = !musicActive
  saveMusicStateToStorage(musicActive)
  updateMusicButtons()
  audioManager.toggleMusic()

  emitter.emit(events.MUSIC_BUTTON_CLICK, musicActive)
}

function updateMusicButtons() {
  musicButtons.forEach((btn) => {
    // Invert the logic: when music is active (playing), add 'off' class
    // when music is inactive (paused), remove 'off' class
    // This reverses the previous behavior to match user expectations
    btn.classList.toggle('off', musicActive)
    btn.setAttribute('aria-pressed', String(musicActive))
  })
}

export default { init, on, off }
